module.exports = __webpack_public_path__ + "img/paci_ar_2.2f30a2b0.png";